'use strict';

// Constructor
var SoftScroll = function() {

  require('velocity-animate');

  var self = this;

  self.config = {
    'button'  :  $('[data-soft-scroll]')
  }

  var $button = self.config.button;

  self.clickHandler = function() {

    $button.on('click', function(e) {

      var $this = $(this);
      var hash = $this.attr('data-soft-scroll');
      var $target = $($this.attr('data-soft-scroll'));
      var addHashToUrl = function() {
        if (history.pushState) {
          history.pushState(null, null, hash);
        }
      };

      if ($this.is('a')) {
        e.preventDefault();
      }

      self.scrollAnimation($target, addHashToUrl);
    });
  }

  self.scrollAnimation = function(target, cb) {

    target
      .velocity('stop')
      .velocity(
      'scroll',
      {
        duration: 1700,
        easing: 'easeOutQuart',
        mobileHA: false,
        offset: -165,
        complete: function() {

          if (cb) {
            cb();
          }
        }
      }
    );
  }

  self.init = function(target, cb) {

    self.clickHandler();
  }
};

module.exports = SoftScroll;
